<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <div class="row flex-flow-column">
          <div class="col title">
            <p>{{ $t("allHotels.title") }}</p>
          </div>
          <p class="desc">{{ $t("allHotels.desc") }}</p>
        </div>
        <CButton
          @click="navigateToAddNew(null)"
          size="sm"
          color="info"
          class="ml-auto mob-w100"
        >{{ $t("allHotels.addNew") }}</CButton>
      </CCardHeader>

      <CCardBody class="user-manage-table pt-0px">
        <CRow>
          <!-- <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
              <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
              <span>{{$t("cAlert.errorCode")+' : '}}</span>
              <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
              <p>{{alertValue}}</p>
            </div>
          </CAlert> -->
        </CRow>
        <cAlertModal
        v-if="isShowAlertModal"
        :key="'CA'+alertCount"
        :buttonList="modalButton"
        :status="modalStatus"
        :isShowIcon="true"
        :show="isShowAlertModal"
        :desc="confirmTxt"
      ></cAlertModal>
        <div class="row tq-header-nav">
          <div class="col" md="8">
            <div class="row">
              <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
                <div>
                <label class="title d-flex justify-content-between max-w-400">{{$t('allHotels.hotelDp') }}</label>
                </div>
                  <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="hotel.hotelName"
                    :options="hotelList"
                    :multiple="false"
                    :group-select="false"
                    :custom-label="getHotelNameId"
                    :placeholder="$t('allHotels.hotelDp') "
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    v-on:input="getSelHotelName"
                    :searchable="true"
                    @search-change="addCssClass()"
                  >
                     <template slot="singleLabel"  slot-scope="props">
                       <div>
                             
                             
                                {{props.option['name']}}
                       </div>
                       </template>  

                    <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['name'] }}</span>
                     <strong v-if="props.option['name']!='All'" class="right ml-auto">
                                          {{
                                          props.option['code']
                                          }}
                                        </strong>
                  </div>
                </template>
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
                
              </div>
              
              <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
                <div>
                  <label  class="title d-flex justify-content-between max-w-400" >{{$t('allHotels.cntryDp') }}</label>
                </div>
                   <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="hotel.country"
                    :options="countryLs"
                    :multiple="false"
                    :group-select="false"
                    :placeholder="$t('allHotels.cntryDp') "
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    :searchable="true"
                    v-on:input="getSelCountry"
                    @search-change="addCssClass()"
                  >
                     <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['name'] }}</span>
                     <strong v-if="props.option['name']!='All'" class="right ml-auto">
                                          {{
                                          props.option['code']
                                          }}
                                        </strong>
                  </div>
                </template>
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
              </div>
              <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
                <div>
                  <label  class="title d-flex justify-content-between max-w-400" >{{$t('allHotels.cityDp') }}</label>
                </div>
                <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="hotel.city"
                    :options="cityLs"
                    :multiple="false"
                    :group-select="false"
                    :placeholder="$t('allHotels.cityDp') "
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    v-on:input="getSelCity"
                    :searchable="true"
                    @search-change="addCssClass()"
                  >
                  <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['name'] }}</span>
                     <strong v-if="props.option['name']!='All'" class="right ml-auto">
                                          {{
                                          props.option['code']
                                          }}
                                        </strong>
                  </div>
                </template>
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
              </div>
              <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
                <div>
                  <label  class="title d-flex justify-content-between max-w-400" >
                    {{$t('allHotels.statusDp') }}</label>
                    </div>
                <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="hotel.status"
                    :options="statusLs"
                    :multiple="false"
                    :group-select="false"
                    :placeholder="$t('allHotels.statusDp')"
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    v-on:input="getSelStatus"
                    :searchable="true"
                    @search-change="addCssClass()"
                  >
                    
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
              </div>
              <div md="3" sm="6" xs="12" class="col align-center text-left mt-auto">
           
              <div>
                <CButton
                  @click="onApply"
                  class="btn-outline-success ml-0px"
                >{{ $t("ticketingQueue.apply") }}</CButton>
              </div>
           
          </div>
            </div>
          </div>
        </div>

        <CRow
          class="fullscreen-ex-row"
          
        >
        <!-- v-if="lsallHotelsItems && lsallHotelsItems.length!=0"  -->
          <CCol id="user-manage-table" class="usersTable border-grey manage-user-table">
            <cTable
              :fields="lsallHotelsFields"
              :items="tableFiltereditems?tableFiltereditems:lsallHotelsItems"
              caption="Hotel List"
              column-filter
              items-per-page-select
               @row-clicked="navigateToInfo"
              :items-per-page="allHotelsTableWatchList.itemsPerPage"
              hover
              :sorter="{  resetable: true }"
              :pagination="paginationSettings"
              @update:column-filter-value="saveFilterValue"
              :loading="isLoading"
              class="w-100 d-flex flex-flow-wrap"
              :sorterValue="{ column: 'name', asc: 'true' }"
              @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
              :tableWatchList="allHotelsTableWatchList"
              @getFields="onSaveColumns"
              :manageColumn="true"
              :paginationLenOption="true"
              :showColumnFilter="false"
              @isCustomFilter="getCustomFilter"
            >
               
               
             <template #hotelName="{item}">
               <td >
                <CRow>
                   <div class="px-2">
                     <cHotelThumbnail :imgURL="(item.imageBaseurl && item.imageUrlLow)?item.imageBaseurl+item.imageUrlLow:null" />
                   </div>
                   <CCol class="cap">
                      {{item.hotelName}}
                   </CCol>
                 </CRow>
                             
               </td>
               
             </template>
             <template #contactNumber="{item}">
                <td >
            <div v-if="item.contactNumber">
                   <div v-for="(num,conIndex) in item.contactNumber.split(',')" :key="conIndex">
                                           {{num}}
                       </div>
            </div>
             </td>

                   
                  
             </template>
              <!-- <template #sub-over-table>
                <div class="table-count-wrap mt-20px-imp min-w-100per">
                  <div class="d-inline-flex">
                    <div class="single-tab" v-if="supGrpCount&&supGrpCount.total">
                      <div class="tc-total-wrap">
                        <span>{{ $t("allHotels.suppGrps") }}</span>
                        <span>{{ supGrpCount.total}}</span>
                      </div>
                    </div>

                    <div class="single-tab" v-if="supGrpCount&&supGrpCount.active!=null">
                      <div class="tc-active-wrap">
                        <span>{{ $t("allHotels.active") }}</span>
                        <span>{{supGrpCount.active}}</span>
                      </div>
                    </div>
                    <div
                      class="single-tab"
                      v-if="supGrpCount&&(supGrpCount.inactive||supGrpCount.inactive==0)"
                    >
                      <div class="tc-inactive-wrap">
                        <span>{{ $t("allHotels.inactive") }}</span>
                        <span>{{supGrpCount.inactive}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template> -->
              
              
              <template v-if="isCustomFilter" #isActive-filter>
               
                <div >
                  <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="columnFilterValue.status"
                    :options="statusLs"
                    :multiple="false"
                    :group-select="false"
                    :placeholder="$t('allHotels.status')"
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    v-on:input="onStatusChange"
                    :searchable="true"
                    @search-change="addCssClass()"
                  >
                    
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
                </div>
              </template>

              <template v-if="isCustomFilter" #starRating-filter>
                <div >
                  <multiselect
                    :allow-empty="false"
                    :showLabels="false"
                    :clearOnSelect="false"
                    v-model="columnFilterValue.rating"
                    :options="ratingLs"
                    :multiple="false"
                    :group-select="false"
                    :placeholder="$t('allHotels.status')"
                    track-by="code"
                    label="name"
                    class="mt-auto"
                    v-on:input="onRatingChange"
                    :searchable="true"
                    @search-change="addCssClass()"
                  >
                    
                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                  </multiselect>
                </div>
              </template>

              <template #isActive="{item}">
                <td>
                  <CBadge :color="item.isActive ? 'success' : 'danger'">
                    {{
                   item.isActive?'Active':'Inactive'
                    }}
                  </CBadge>
                </td>
              </template>

              

              <!-- <template #no-items-view>
                <div class="text-center my-5">
                  <h2>{{isLoading?'':$t("allHotels.listEmpty") }}</h2>
                </div>
              </template> -->

              <template v-if="isCustomFilter" #actions-filter>
                <td style="border-top: 0px;
                    height: 100%;">
                  <div  @click="clearAllFilters()" class="clear-filter-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      id="Capa_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 373.6 373.6"
                      style="enable-background:new 0 0 373.6 373.6; fill:#1e90ff;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M343.7,0H29.9c-5.5,0-10.1,4.9-10.1,10.5v64.2c0,0.3,0,0.6,0.1,1c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.1,0.5    c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0.1,0.3,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.5c0,0.1,0.1,0.2,0.1,0.4c0.1,0.2,0.1,0.3,0.2,0.5    c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.3,0.3,0.4    c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.1,0.2,0.2l114.3,124.6v157.5c0,3.9,2.2,7.4,5.7,9.1c1.3,0.6,2.7,0.9,4.2,0.9    c2.4,0,4.7-0.8,6.5-2.4l80.2-68.3c2.2-1.9,3.5-4.7,3.4-7.6v-89.2L351,81.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.4    c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.2,0.2-0.3,0.3-0.4s0.2-0.3,0.2-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.4    c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0.1-0.3,0.1-0.5    s0.1-0.3,0.1-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.3,0.1-0.6,0.1-1V10.4C353.8,4.9,349.3,0,343.7,0z M219.5,195.6    c-1.7,1.8-2.7,4.1-2.7,6.6v88.4l-60,51.3V202.2c0-2.5-1-4.8-2.7-6.6L52.6,85H321L219.5,195.6z M333.8,65h-294V20h294V65z"
                          />
                        </g>
                      </g>
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                      <g />
                    </svg>
                    {{$t('manageUser.clearFilter')}}
                  </div>
                </td>
              </template>
              <template #no-items-view>
                <div  class="text-center my-5">
                  <h2>{{isLoading?'':$t("allHotels.listEmpty") }}</h2>
                </div>
              </template>

              <template #actions="{item}">
                <td class="py-2 d-flex ai-center">
                 <div class="row">
                  <!-- <CCol>
                     <div
                    col="2.5"
                    size="sm"
                    color="info removewrap"
                    @click.stop="navigateToAddNew(item)"
                     v-c-tooltip.hover="{ content: $t('allHotels.view') , active:false }"
                    class=" icon-25px c-pointer"
                      >
                      <div class="filled-icon-btn r-payment">
                              <img src="@imgPath/img/svg/icons/view.svg" alt="">
                      </div>
                     </div>
                  </CCol> -->
                   <CCol>
                      <div
                              @click.stop=" navigateToInfo(item)"                              
                              class="px-2 edit-icon icon-25px c-pointer"
                              color="info removewrap"
                              v-c-tooltip.hover="{ content: $t('allHotels.edit') , active:false }"
                      >
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="512pt"
                                viewBox="0 0 512 512"
                                width="512pt"
                                style="fill:#3c4b64;"
                        >
                          <path
                                  d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                                  d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                                  d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                </CCol>

                    <CCol>
                      <div
                             @click.stop="onConfirmDeleteHotel(item)"                                                            
                              color=" danger"
                              v-c-tooltip.hover="{ content: $t('allHotels.delete') , active:false }"
                              class=" icon-25px c-pointer"
                      >
                        <CIcon style="color: #cd0606;font-size:22px;" name="cil-trash" size="lg"></CIcon>
                      </div>
                    </CCol>
                 </div>
                </td>
              </template>
            </cTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
     <cAlertModal
      v-if="isShowAlertModal"
      :key="'manageHotel'+alertCount"
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="true"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  </div>
</template>

<script>
import cDropDown from "../../../components/form/cDropDown";
import router, { navigate } from "../../../router/index";

import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  ALERT_MODAL_STATUS,
  ORDER,
} from "../../../util/constants";
import apiDeleteSupplierGrp from "../../../services/apiDeleteSupplierGrp";
import apiGetAllHotels from "../../../services/apiGetAllHotels";
import Logger from "../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../config/API_DATA";

import multiselect from "vue-multiselect";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,cloneData
} from "../../../util/util";
import BaseConfiguration from "../../../config/base.js";
import cPaginationLenOption from "../../../components/dataTable/cPaginationLenOption";
import cFullScreen from "../../../components/cFullScreen";
import cManageColumns from "../../../components/dataTable/cManageColumns";
import cTable from "../../../components/dataTable/cTable";
import cAlertModal from '../../../components/form/cAlertModal'

import apiGetCitiesforHotel from "../../../services/apiGetCitiesforHotel.js";
import apiDeleteHotel from "../../../services/apiDeleteHotel";
import apiGetHmsAllEnums from "../../../services/apiGetHmsAllEnums";
import cHotelThumbnail from '../../../components/hms/manage/hotelInfo/cHotelThumbnail'

export default {
  name: COMPONENT_NAME.MANAGE_ALL,
  components: {
      cAlertModal,
    cDropDown,
    cTable,
    multiselect,
    cHotelThumbnail
  },

  data: () => {
    return {
      supGrpCount: null,
      isCustomFilter:true,
      allHotelsTableWatchList: {
        filteredlistCount: null,
        itemsPerPage: 25,
        currentPageNum: 1,
      },
      
      hotel:{
          hotelName: null,
          city:null,
          country:null,
          status:null
      },
      columnFilterValue:{
        hotelName: null,
        hotelCode: null,
        rating: {
        name: DEFAULT_DROPDOWN_STATUS.ALL,
        code: DEFAULT_DROPDOWN_STATUS.ALL,
      },
      status: {
        name: DEFAULT_DROPDOWN_STATUS.ALL,
        code: DEFAULT_DROPDOWN_STATUS.ALL,
      },
      suppName: null,
      city: null,
      country: null,
      contactno: null
      },
      
      paginationSettings: {
        align: "end",
      },
      alertValue: null,

      lsallHotels: [],
      lsallHotelsItems: [],
      lsallHotelsFields: [],
      isLoading: true,
      hotelList: [],
      cityLs: [],
      countryLs: [],
      statusLs: [],
      ratingLs:[],
      alertCount:0,
       modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      isShowAlertModal: false,
      confirmTxt:null,
      alertCount:0,
     selHotelObj:null,
     applied:false,
     tableFilterObj: null,
     tableFiltereditems:null,
   
      //fullscreen: false
    };
  },

  methods: {
    ...mapActions("shmsManage", {
      SET_HOTEL_LS: "SET_HOTEL_LS",
      SET_SEL_HOTEL: "SET_SEL_HOTEL",
      SET_APPLY_HOTEL_LS: "SET_APPLY_HOTEL_LS",
      SET_ALL_ENUMS:"SET_ALL_ENUMS"
    }),
     ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
      SET_HOTEL_SEARCH_OBJ: "SET_HOTEL_SEARCH_OBJ"}),
      ...mapActions('sHotelInfo',{
        SET_HOTEL_OBJ:"SET_HOTEL_OBJ",
         SET_ACTIVE_TAB:"SET_ACTIVE_TAB",
          SET_HOTEL_ROOM_OBJ: "SET_HOTEL_ROOM_OBJ",
      }),
      



      getHotelNameId({name,code})
      {


 return `${name} — [${code}]`
      },
      getCustomFilter(pisCustomFilter){
        this.isCustomFilter = pisCustomFilter;
      },

      showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("createHotel.noBtn"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("createHotel.yesBtn"),
            func: this.onDeleteHotel
          }
        ];
      } else if (
        status == ALERT_MODAL_STATUS.SUCCESS 
      ) {
        this.modalButton = [
          {
            name: this.$t("createHotel.okBtn"),
            func: this.onSuccessDelete
          }
        ];
      }else if(status==ALERT_MODAL_STATUS.FAIL){
        this.modalButton = [
          {
            name: this.$t("createHotel.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
    },
     toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      // this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },  
    onSuccessDelete() {
        try {
          if(BaseConfiguration.isDebug) console.log("onSuccessDelete");
          this.isShowAlertModal=false;
          this.toGetAllHotels();
    
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.MANAGE_ALL,
                  "error in onSuccessDelete",
                  err.toString(),
                  "onSuccessDelete",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         ;
        }, 

   async onDeleteHotel() {
      
        try {
          if(BaseConfiguration.isDebug) console.log("onDeleteHotel");
          if(this.selHotelObj&&this.selHotelObj.hotelid){
          let hotelDeleteRes=await this.deleteHotel(this.selHotelObj.hotelid);
          if(hotelDeleteRes){
            this.showAlertModal(ALERT_MODAL_STATUS.SUCCESS, this.$t("createHotel.deleteHotelSuccDesc"))
          }else{
             this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue)
          }
          }else{
            throw 'invalid hotelid';
          }
         
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.MANAGE_ALL,
                  "error in onDeleteHotel",
                  err.toString(),
                  "onDeleteHotel",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    async deleteHotel(pHotelId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteHotel");
        let hotelReq = apiDeleteHotel.buildRequest(pHotelId);

        if (hotelReq) {
          let hotelRes = await apiDeleteHotel.getResponse(
            hotelReq
          );

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in deleteHotel",
          err.toString(),
          "deleteHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onConfirmDeleteHotel(pHotelObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("onConfirmDeleteHotel");
          this.selHotelObj=pHotelObj;
           this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                this.$t("createHotel.deleteHotelConfirmation")
              );
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in onConfirmDeleteHotel",
                  err.toString(),
                  "onConfirmDeleteHotel",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
    onSaveColumns(pFields) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSaveColumns");
        this.lsallHotelsFields = pFields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onSaveColumns",
          err.toString(),
          "onSaveColumns",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.allHotelsTableWatchList.itemsPerPage = this.maxCountForReport;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.allHotelsTableWatchList.itemsPerPage = pItemsPerPage;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPageChange(pPageNum) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPageChange");
        this.allHotelsTableWatchList.currentPageNum = pPageNum;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in onPageChange",
          err.toString(),
          "onPageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFilteredAgentCount(pFilteredItems) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
        // this.lsallHotelsItems = pFilteredItems;
        this.allHotelsTableWatchList.filteredlistCount =
          pFilteredItems.length;
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.MANAGE_ALL,
          "error in getFilteredAgentCount",
          err.toString(),
          "getFilteredAgentCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },

    // toDeleteSupplierGrp(pGrp) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("toDeleteSupplierGrp");

    //     this.showAlertModal(
    //       ALERT_MODAL_STATUS.INFO,
    //       this.$t("allHotels.deleteConfirm"),
    //       pGrp.id
    //     );
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.EXTENSION_SETUP,
    //       "error in toDeleteSupplierGrp",
    //       err.toString(),
    //       "toDeleteSupplierGrp",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   // return retValue;
    // },

    // showAlertModal(status, val, pParam) {
    //   this.isShowAlertModal = true;
    //   this.alertCount += 1;
    //   this.modalStatus = status;

    //   if (status == ALERT_MODAL_STATUS.INFO) {
    //     this.modalButton = [
    //       {
    //         name: this.$t("allHotels.no"),
    //         func: this.toggleShowAlertModal
    //       },
    //       {
    //         name: this.$t("allHotels.yes"),
    //         func: this.deleteallHotelss,
    //         param: pParam ? pParam : null
    //       }
    //     ];
    //   } else if (status == ALERT_MODAL_STATUS.SUCCESS || status == ALERT_MODAL_STATUS.FAIL) {
    //     this.modalButton = [
    //       {
    //         name: this.$t("allHotels.ok"),
    //         func: this.toGetAllHotels
    //       }
    //     ];
    //   }
    //   this.confirmTxt = val;
    // },

    onApply() {
        let retValue=[];
        try {
          if(BaseConfiguration.isDebug) console.log("onApply");
          
          // if(this.GET_HOTEL_LS && this.applied){
            let grpLs;
            if(this.lsallHotelsItems){
              if((this.hotel.hotelName && this.hotel.hotelName.name=='All') && 
             (this.hotel.city && this.hotel.city.name=='All') 
              && (this.hotel.country && this.hotel.country.name=='All') &&
               (this.hotel.status && this.hotel.status.name=='All')){
                 this.tableFiltereditems =null;
                if( !(this.tableFilterObj && !!this.tableFilterObj.hotelName && !!this.tableFilterObj.hotelid && 
              !!this.tableFilterObj.country && !!this.tableFilterObj.city && !!this.tableFilterObj.contactNumber &&
               !!this.tableFilterObj.supplierName ) && (this.columnFilterValue.status.code!='All'
                && this.columnFilterValue.rating.code!='All')){
                 grpLs = this.GET_HOTEL_LS;
              }
              else{
                grpLs = this.lsallHotelsItems;
              }
             
              }
              else{
                grpLs = this.lsallHotelsItems;
              }
             
              
                  if(this.hotel.hotelName.name!=DEFAULT_DROPDOWN_STATUS.ALL){
                      grpLs.filter(grp => {
                        if(grp.hotelid==this.hotel.hotelName.code){
                          retValue.push(grp);
                       }
                    });
                  } else {
                      retValue = grpLs;
                  }
                  if(this.hotel.city.name!=DEFAULT_DROPDOWN_STATUS.ALL){
                      var filtLs=[];
                      retValue.filter(grp => {
                        if(grp.cityCode==this.hotel.city.code){
                          filtLs.push(grp);
                       }
                    });
                    retValue = filtLs;
                  }
                  if(this.hotel.country.name!=DEFAULT_DROPDOWN_STATUS.ALL){
                      var filtLs=[];
                      retValue.filter(grp => {
                        if(grp.countryCode==this.hotel.country.code){
                          filtLs.push(grp);
                       }
                    });
                     retValue = filtLs;
                  }
                  if(this.hotel.status.name!=DEFAULT_DROPDOWN_STATUS.ALL){
                      var filtLs=[];
                      retValue.filter(grp => {
                        if(grp.isActive==true && this.hotel.status.code==1){
                          filtLs.push(grp);
                       }
                       if(grp.isActive==false && this.hotel.status.code==2){
                          filtLs.push(grp);
                       }
                    });
                    retValue = filtLs;
                  } 
                  
              
          }
          // this.lsallHotelsItems=[];
          this.tableFiltereditems = retValue;

          
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in onApply",
                  err.toString(),
                  "onApply",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    },
    //  onContactNoChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onContactNoChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         var name = item.contactNumber;
    //      return name.toLowerCase().includes(this.columnFilterValue.contactno.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onContactNoChange",
    //       err.toString(),
    //       "onContactNoChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // }, 
    //  onSuppNameChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onSuppNameChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         var name = item.supplierGroup.name;
    //      return name.toLowerCase().includes(this.columnFilterValue.suppName.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onSuppNameChange",
    //       err.toString(),
    //       "onSuppNameChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // }, 
    // onCountryChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onCountryChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         // var name = this.$options.filters.hmsCountryName(item.countryCode);
    //          var name = item.countryCode;
    //      return name.toLowerCase().includes(this.columnFilterValue.country.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onCountryChange",
    //       err.toString(),
    //       "onCountryChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },
    //   onCityChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onCityChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         // var name = this.$options.filters.hmsCityName(item.cityCode);
    //         var name = item.cityCode;
    //      return name.toLowerCase().includes(this.columnFilterValue.city.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onCityChange",
    //       err.toString(),
    //       "onCityChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },
    // onCodeChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onCodeChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         var name = item.hotelid;
    //      return name.toLowerCase().includes(this.columnFilterValue.hotelCode.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onCodeChange",
    //       err.toString(),
    //       "onCodeChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },
    //  onHotelNameChange(filteredLs,pname) {
    //   let retValue;

    //   try {
    //     if (BaseConfiguration.isDebug) console.log("onHotelNameChange");
    //      let grpLs;
    //     grpLs = filteredLs;
    //     if (
    //       grpLs != null &&
    //       grpLs.length > 0 &&
    //       pname
    //     ) {
    //       grpLs = grpLs.filter(item => {
    //         var name = item.hotelName;
    //      return name.toLowerCase().includes(this.columnFilterValue.hotelName.toLowerCase())
    //   });
          
    //     }
    //     retValue = grpLs;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in onHotelNameChange",
    //       err.toString(),
    //       "onHotelNameChange",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // },

    clearAllFilters() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("clearAllFilters");

        
        this.columnFilterValue.status = {
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: DEFAULT_DROPDOWN_STATUS.ALL,
        };
        this.columnFilterValue.rating = {
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: DEFAULT_DROPDOWN_STATUS.ALL,
        };
        if(this.tableFilterObj){
       Object.keys(this.tableFilterObj).forEach(
          (key) => (this.tableFilterObj[key] = "")
        );
        }
        // this.columnFilterValue.city=null
        // this.columnFilterValue.suppName=null
        // this.columnFilterValue.country=null
        // this.columnFilterValue.hotelName=null
        // this.columnFilterValue.hotelCode=null
        // this.columnFilterValue.contactno=null
        if(this.tableFiltereditems && this.tableFiltereditems.length==0){
          this.lsallHotelsItems = JSON.parse(JSON.stringify(this.GET_HOTEL_LS));
          this.onApply();
          // this.lsallHotelsItems = JSON.parse(JSON.stringify(this.lsallHotelsItems));
        }else{
          this.lsallHotelsItems = JSON.parse(JSON.stringify(this.GET_HOTEL_LS));
        }
         
        // this.lsallHotelsItems = JSON.parse(
        //   JSON.stringify(this.lsallHotels)
        // );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in clearAllFilters",
          err.toString(),
          "clearAllFilters",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    saveFilterValue(pFilterObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("saveFilterValue");
        if (pFilterObj) {
         this.tableFilterObj = pFilterObj;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in saveFilterValue",
          err.toString(),
          "saveFilterValue",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getallHotelsFields() {
      let returnValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getallHotelsFields");

        let lsFields = [
          //     {
          //     key: "id",
          //     // _style: "width:30%",

          //     label: this.$t("allHotels.regNo"),
          //     isLocked: true,
          //   },
          {
            key: "hotelName",            
            label: this.$t("allHotels.hotelName"),
            isLocked: true,
          },
          {
            key: "hotelid",            
            label: this.$t("allHotels.hotelCode"),
            isLocked: true,
          },
          {
            key: "starRating",            
            label: this.$t("allHotels.starRating"),
            sorter: false,
            filter: false,
            isLocked: true,
          },

          {
            key: "country",
            label: this.$t("allHotels.country"),
            isLocked: false,
          },
          {
            key: "city",
            label: this.$t("allHotels.city"),
            isLocked: false,
          },
          {
            key: "contactNumber",            
            label: this.$t("allHotels.conNum"),
            sorter: false,
            isLocked: false,
          },
          {
            key: "supplierName",
            label: this.$t("allHotels.supplier"),
            isLocked: false,
          },

          {
            key: "isActive",
            style: "width:30%",
            label: this.$t("allHotels.status"),
            sorter: false,
            filter: false,
            isLocked: true,
          },

          {
            key: "actions",
            label: this.$t("allHotels.action"),
            sorter: false,
            filter: false,
            isLocked: true,
          },
        ];

        returnValue = lsFields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in getallHotelsFields",
          err.toString(),
          "getallHotelsFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    showAlert(value) {
      this.alertValue = value;
    },

    getSelStatus(pSelStatus) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelStatus");
          this.hotel.status = pSelStatus
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in getSelStatus",
                  err.toString(),
                  "getSelStatus",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    getSelCountry(pSelCountry) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelCountry");
          this.hotel.country = pSelCountry
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in getSelCountry",
                  err.toString(),
                  "getSelCountry",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

     getSelCity(pSelCity) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelCity");
          this.hotel.city = pSelCity
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in getSelCity",
                  err.toString(),
                  "getSelCity",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    getSelHotelName(pSelHotelName) {
        let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelHotelName");
          this.hotel.hotelName = pSelHotelName
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in getSelHotelName",
                  err.toString(),
                  "getSelHotelName",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 
    
onRatingChange(pRating) {
  let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("onRatingChange");
         let grpLs;
        //  if(this.GET_HOTEL_LS){
        //       grpLs = filteredLs
        //  }
        this.tableFiltereditems =null;
          if(this.lsallHotelsItems){
              grpLs = this.GET_HOTEL_LS
         }
        if (
          grpLs != null &&
          grpLs.length > 0 &&
          pRating
        ) {
        //  let status = this.status;
         this.rating = pRating;
          grpLs = grpLs.filter( 
            function (user) {
              if ( user.starRating == pRating.name) {
                return true;
              } else if (pRating.name == DEFAULT_DROPDOWN_STATUS.ALL) {
                return true;
              }else {
                return false;
              }
            }
            
          );
          this.lsallHotelsItems = cloneData(grpLs);
        } else {
          // this.lsallHotelsItems = this.lsallHotelsItems;
        }
     retValue = grpLs;
        // this.resetUserRole();
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in on Rating Change",
          err.toString(),
          "onRatingChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},

    onStatusChange(pStatus) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("onStatusChange");
         let grpLs;
        //  if(this.GET_HOTEL_LS){
        //       grpLs = filteredLs
        //  }
        this.tableFiltereditems =null;
         if(this.lsallHotelsItems){
              grpLs = this.GET_HOTEL_LS
         }
        if (
          grpLs != null &&
          grpLs.length > 0 &&
          pStatus
        ) {
            let rating = this.rating;
         this.status = pStatus;
          grpLs = grpLs.filter(
            function (user) {
              if (
                user.isActive==true && pStatus.name=='Active'
              ) {
                return true;
              } else if (
                user.isActive==false && pStatus.name=='Inactive'
              ) {
                return true;
              }else if (
                pStatus.name == DEFAULT_DROPDOWN_STATUS.ALL 
              ) {
                return true;
              } else {
                return false;
              }
            }
            
          );
          this.lsallHotelsItems = cloneData(grpLs);
        } 
retValue = grpLs;
        // this.resetUserRole();
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in on Status Change",
          err.toString(),
          "onStatusChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},



    
    navigateToInfo(pSelectedHotelObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToInfo");
        // if(pSelectedHotelObj){
        //     this.SET_SEL_HOTEL(pSelectedHotelObj)
        //     this.SET_HOTEL_OBJ(pSelectedHotelObj)
              
        // }else{
        //     this.SET_SEL_HOTEL(null)
        //        this.SET_HOTEL_OBJ(null)
        // }
        let param={
          hotelId: pSelectedHotelObj.hotelid
        }
       this.SET_ACTIVE_TAB(null)
       this.      SET_HOTEL_ROOM_OBJ(null),
      navigate(PATHNAME.HOTEL_INFO,param)
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in navigate To Hotel info",
          err.toString(),
          "navigateToInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  

    navigateToAddNew(pSelectedGroupObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToAddNew");
        // if(pSelectedGroupObj){
        //     this.SET_SEL_HOTEL(pSelectedGroupObj)
        // }else{
            this.SET_SEL_HOTEL(null)
        // }
        navigate(PATHNAME.MANAGE_HOTEL_NEW)
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in navigate To User Status",
          err.toString(),
          "navigateToAddNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    //  async deleteallHotelss(pId) {
    //   let returnValue;
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("deleteallHotelss");

    //     let deleteallHotelsRequest = apiDeleteSupplierGrp.buildRequest(pId);

    //     if (deleteallHotelsRequest != null) {
    //       let deleteallHotelsResponse = await apiDeleteSupplierGrp.getResponse(
    //         deleteallHotelsRequest
    //       );
    //       if (VALIDATE_SUCCESS_RES(deleteallHotelsResponse)) {
    //        this.alertValue=null;

    //         returnValue = deleteallHotelsResponse.data.data;
    //         this.showAlertModal(
    //           ALERT_MODAL_STATUS.SUCCESS,
    //           this.$t("allHotels.deleteSuccess")
    //         );
    //       } else {
    //         let error = getErrorMessage(deleteallHotelsResponse);

    //         let isJwt = handleJWT(error);
    //         if (!isJwt) {
    //           this.showAlert(getErrorAlertValue(error,true,true));
    //         }
    //         this.showAlertModal(
    //           ALERT_MODAL_STATUS.FAIL,
    //           this.alertValue
    //         );
    //       }
    //     } else {
    //       throw "invalid request";
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.MANAGE_ALL,
    //       "error in  deleteallHotelss",
    //       err.toString(),
    //       "deleteallHotelss",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return returnValue;
    // },

    async getAllHotels() {
      let returnValue;
      try {
        this.isShowAlertModal = false;
        if (BaseConfiguration.isDebug) console.log("getAllHotels");

        let allHotelsRequest = apiGetAllHotels.buildRequest();

        if (allHotelsRequest != null) {
          let allHotelsResponse = await apiGetAllHotels.getResponse(
            allHotelsRequest
          );
          if (VALIDATE_SUCCESS_RES(allHotelsResponse)) {
            returnValue = allHotelsResponse.data.data.list;

                       returnValue.forEach(hotel=>{
                        
                         hotel["country"] = 
                         this.$options.filters.hmsCountryName(hotel.countryCode);
                          hotel["city"]= 
                         this.$options.filters.hmsCityName(hotel.cityCode);
                         if(hotel.supplierName)
                         hotel.supplierName=hotel.supplierName
                         else
                          hotel.supplierName=''
                       })
            this.SET_HOTEL_LS(returnValue);

            this.showAlert(null);
          } else {
            let error = getErrorMessage(allHotelsResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in  get All Users",
          err.toString(),
          "getAllHotels",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    getallHotelsItems(pallHotelsResponse) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getallHotelsItems");

        if (pallHotelsResponse && pallHotelsResponse.length > 0) {
          pallHotelsResponse.forEach((value) => {
            this.lsallHotels.push({
              name: value.name,
              country: value.countryCode,
              address: value.cityCode,
              contactPersonname: value.contactPersonname,
              contactNumber: value.contactNumber,
              status: value.isActive ? "Active" : "Inactive",
            });
          });
        } else {
          this.lsallHotels = [];
        }
        retValue = JSON.parse(JSON.stringify(this.lsallHotels));
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in  getallHotelsItems",
          err.toString(),
          "getallHotelsItems",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },
    getPropToSortGroups(pallHotels) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPropToSortGroups");
        if (pallHotels.hotelName) {
          return pallHotels.hotelName.toLowerCase();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error in getPropToSortGroups",
          err.toString(),
          "getPropToSortGroups",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toGetListofDp(pHotelLs) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toGetListofDp");
        if (pHotelLs) {
          var grpLs = [];
          var cityLs = [];
          var countryLs = [];
          var statusLs = [];
          var rating = [];
          var count = {
              active : 0,
              inactive : 0,
              total: 0
          }
          count.total = pHotelLs.length;
          grpLs.push({
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: 'All'
        })
        cityLs.push({
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: 'All'
        })
        countryLs.push({
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: 'All'
        })
        statusLs.push({
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: 'All'
        })
        rating.push({
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          code: 'All'
        })
          for (let i = 0; i < pHotelLs.length; i++) {
            grpLs.push({name:pHotelLs[i].hotelName,code:pHotelLs[i].hotelid});
            cityLs.push({name:pHotelLs[i].city,code:pHotelLs[i].cityCode});
            countryLs.push({name:pHotelLs[i].country,code:pHotelLs[i].countryCode});
            rating.push({name:pHotelLs[i].starRating,code:pHotelLs[i].starRating});
            if(pHotelLs[i].isActive) {
                count.active=count.active+1;
            }
            if(!pHotelLs[i].isActive) {
                count.inactive=count.inactive+1;
            }
          }
          statusLs.push({name:'Active',code:1}),
          statusLs.push({name:'Inactive',code:2})
          cityLs= Array.from(new Set(cityLs.map(JSON.stringify))).map(JSON.parse);
          countryLs= Array.from(new Set(countryLs.map(JSON.stringify))).map(JSON.parse);
          rating= Array.from(new Set(rating.map(JSON.stringify))).map(JSON.parse);
          this.hotelList = grpLs;
          this.cityLs = cityLs;
          this.countryLs = countryLs;
         this.statusLs =  statusLs;
         this.ratingLs = rating;
         this.supGrpCount = count;
        }
      } catch (err) {
        let body = Logger.buildRequest(

          COMPONENT_NAME.MANAGE_ALL,
          "error in toGetListofDp",
          err.toString(),
          "toGetListofDp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async toGetAllHotels() {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toGetAllHotels");
         let allHotels = [];
      allHotels = await this.getAllHotels();
       

      this.toGetListofDp(allHotels);
      if(this.hotelList.length!=0 && this.cityLs.length!=0 && 
      this.countryLs.length!=0 && this.statusLs.length!=0){
      this.hotel.hotelName = this.hotelList[0];
      this.hotel.city = this.cityLs[0];
      this.hotel.country = this.countryLs[0];
      this.hotel.status = this.statusLs[0];
      }
      allHotels = OrderByList(
        allHotels,
        this.getPropToSortGroups,
        ORDER.ASC
      );
      if(allHotels){
          this.lsallHotelsItems =   JSON.parse(JSON.stringify(allHotels));
      }else{
        this.lsallHotelsItems =[];
      }
      retValue = allHotels;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.MANAGE_ALL,
                  "error in toGetAllHotels",
                  err.toString(),
                  "toGetAllHotels",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
          async getRoutesResponse() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

        let getRoutesRequest = apiGetCitiesforHotel.buildRequest();

        if (getRoutesRequest) {
          // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
          let getRouteResponse = await apiGetCitiesforHotel.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store
            retValue = getRouteResponse.data.data;
            this.SET_HOTEL_ROUTES_OBJ(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},
 ///to change class of city picker
            addCssClass() {
                //
                try {
                    if (BaseConfiguration.isDebug) console.log("addCssClass");

                    let countryTitleLIst = document.getElementsByClassName(
                        "multiselect__option--disabled"
                    );
                    setTimeout(() => {
                        for (let index = 0; index < countryTitleLIst.length; index++) {
                            const element = countryTitleLIst[index];
                            element.parentNode.classList.add("active");
                        }
                    },100);

                } catch (error) {
                    //ignore
                }
            },

      async getHmsAllEnums() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHmsAllEnums");

        let getRoutesRequest = apiGetHmsAllEnums.buildRequest();

        if (getRoutesRequest) {
         
          let getRouteResponse = await apiGetHmsAllEnums.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            
            retValue = getRouteResponse.data.data;
            this.SET_ALL_ENUMS(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_ALL,
          "error while getting response from getHmsAllEnums API",
          err.toString(),
          "getHmsAllEnums",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
},
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      
      let allHotels = [];
     
      this.lsallHotelsFields = this.getallHotelsFields();
     
      if (this.routeObj != null) {
        this.routesResponse = cloneDeep( this.routeObj);
      } else {
        this.routesResponse = await this.getRoutesResponse();
      }
      
      if(this.routesResponse){
      allHotels =await this.toGetAllHotels();
      }
      
      
      await this.getHmsAllEnums();
       
      this.isLoading = false;
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.MANAGE_ALL,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
  //  hotelComputedLs: {
  //       get: function () {
         
  //         let filteredLs=null;
  //       if(this.GET_APPLY_HOTEL_LS){
  //         filteredLs = cloneDeep(this.GET_APPLY_HOTEL_LS)
  //       }
  //       else 
  //       if(this.GET_HOTEL_LS){
  //             filteredLs = cloneDeep(this.GET_HOTEL_LS)
  //        }
  //       if(this.columnFilterValue.hotelName){
  //         filteredLs = this.onHotelNameChange(filteredLs,this.columnFilterValue.hotelName)
  //       }if(this.columnFilterValue.hotelCode){
  //         filteredLs = this.onCodeChange(filteredLs,this.columnFilterValue.hotelCode)
  //       } if(this.columnFilterValue.rating.name != DEFAULT_DROPDOWN_STATUS.ALL){
  //         filteredLs = this.onRatingChange(filteredLs,this.columnFilterValue.rating)
  //       }if(this.columnFilterValue.city){
  //         filteredLs = this.onCityChange(filteredLs,this.columnFilterValue.city)
  //       }  if(this.columnFilterValue.country){
  //         filteredLs = this.onCountryChange(filteredLs,this.columnFilterValue.country)
  //       }  if(this.columnFilterValue.suppName){
  //         filteredLs = this.onSuppNameChange(filteredLs,this.columnFilterValue.suppName)
  //       }  if(this.columnFilterValue.status.name != DEFAULT_DROPDOWN_STATUS.ALL){
  //         filteredLs = this.onStatusChange(filteredLs,this.columnFilterValue.status)
  //       }  if(this.columnFilterValue.contactno){
  //         filteredLs = this.onContactNoChange(filteredLs,this.columnFilterValue.contactno)
  //       } 
  //       if(this.applied){
  //       filteredLs = this.onApply(filteredLs);
  //       this.SET_APPLY_HOTEL_LS(filteredLs);
  //        this.applied=false;
  //        }
  //        if((this.hotel.hotelName && this.hotel.hotelName.name=='All') && 
  //            (this.hotel.city && this.hotel.city.name=='All') 
  //             && (this.hotel.country && this.hotel.country.name=='All') &&
  //              (this.hotel.status && this.hotel.status.name=='All')){
  //          this.SET_APPLY_HOTEL_LS(null);
  //        }
  //       return filteredLs;
  //     },

  //     set: function() {

  //     }
      
  //   },
    ...mapGetters("shmsManage", {
      GET_HOTEL_LS: "GET_HOTEL_LS",
      GET_APPLY_HOTEL_LS: "GET_APPLY_HOTEL_LS"
    }),
     ...mapGetters("sHotelSearch", {
      routeObj: "GET_HOTEL_ROUTES_OBJ",
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.MANAGE_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>
<style >

 .tc-total-wrap, .tc-inactive-wrap, .tc-active-wrap {
      max-width: calc(15vw - 38px);
      width: calc(50vw - 38px);
    }
  
    .table-count-wrap {
        transform: translateX(0px);
        transform: translateY(25px);
        margin-left: 0px;
        margin-top: 0px;
      }
    .tc-active-wrap {
          background: #41b883;
        }
    .tc-inactive-wrap {
          background: #e03232;
        }
      .tc-total-wrap {
          background: skyblue;
        }
    .tc-total-wrap, .tc-active-wrap {
      margin-bottom: 40px;
    }
     ul.pagination.justify-content-end {
    margin: auto;
    margin-right: 0;
  }
   
  .single-tab {
      margin-right: 10px;
    }
</style>
